import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import MuiButton from 'src/components/mui/MuiButton'
import { useAppDispatch, useAppSelector } from 'src/store/index'
import { handleMessageAlertClose } from 'src/store/slice/RootMessageAlertSlice'
import './RootMessageAlert.css'


const RootMessageAlert = () => {
  const { open, type, message, callback } = useAppSelector((state) => state.RootMessageAlertSlice)
  const dispatch = useAppDispatch()

  const dialogTitle = () => {
    let title = 'Message Code: '
    let label = ''
    if (type === 'required') {
      title += `01000-W-002`
      label = 'Please input the following mandatory field(s):'
    }
    if (type === 'invalid') {
      title += `01000-W-018`
      label = 'The following fields are invalid:'
    }
    return { title, label }
  }

  const handleClose = () => {
    dispatch(handleMessageAlertClose())
  }

  const handleOkButtonClick = () => {
    if (typeof callback === 'function') callback('ok')
    handleClose()
  }

  return (
    <Dialog
      className='root-message-alert'
      open={open}
      keepMounted
    >
      <DialogTitle>
        <div className='message-dialog-title'>
          <b>{dialogTitle()['title']}</b>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className='message-dialog-content'>
          <div className='message-icon'>
            <WarningAmberIcon color='primary' fontSize='large' />
          </div>
          <div className='message-texts'>
            <div className='message-label'>
              <span>{dialogTitle()['label']}</span>
            </div>
            <div className='message-values'>
              {message.map((item) => <div key={item}>{item}</div>)}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className='message-dialog-actions'>
          <div>
            <MuiButton variant='outlined' onClick={handleOkButtonClick}>确定</MuiButton>
          </div>
          <div>
            <MuiButton variant='outlined' onClick={handleClose}>取消</MuiButton>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default RootMessageAlert
